module.exports = __webpack_public_path__ + "img/comment-ico.9854b8b0.svg";